const priorityReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default priorityReducer;